import { render } from "./hazardsCard.vue?vue&type=template&id=2353925c&scoped=true"
import script from "./hazardsCard.vue?vue&type=script&lang=js"
export * from "./hazardsCard.vue?vue&type=script&lang=js"

import "./hazardsCard.vue?vue&type=style&index=0&id=2353925c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2353925c"]])

export default __exports__